export class StpOrganizationAddressUpdateRequest {
  stpMainId: number;
  organizationContactNo: string;
  organizationEmail: string;
  representativeName: string;
  representativeDesignation: string;
  representativeContactNo: string;
  representativeEmail: string;
  firstTime: boolean;
}
